// 表示する通知数の最大数。これ以上は "[最大数]+" と表記
export const NUM_NOTIFICATIONS_THRESHOLD = 99;
